import { useWhatsappCardForm } from "@/components/shared/forms/whatsapp-card-form";
import type { WhatsappCard } from "@stackje/common/config";

interface EditWhatsappCardProps {
  card: WhatsappCard;
  cardIndex: number;
}

export function EditWhatsappCard({ card }: EditWhatsappCardProps) {
  const { formContent, previewContent, shuffleColors, toggleType, handleSubmit } = useWhatsappCardForm({
    initialData: {
      whatsappNumber: card.whatsappNumber || "",
      initialMessage: card.initialMessage || "",
      buttonText: card.buttonText || "",
      title: card.title || "",
      description: card.description || "",
      type: card.type,
      colors: card.colors,
    },
    mode: "edit",
  });

  return {
    formContent,
    previewContent,
    shuffleColors,
    toggleType,
    handleSubmit,
  };
}